/**
 * Keyboard shortcut help overlay (Phase 4). Triggered by `?`.
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from './ui/Dialog';

interface KeyboardHelpProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

interface Shortcut {
  keys: string[];
  description: string;
}

const SHORTCUTS: Array<{ group: string; items: Shortcut[] }> = [
  {
    group: 'Navigation',
    items: [
      { keys: ['j'], description: 'Next submission' },
      { keys: ['k'], description: 'Previous submission' },
      { keys: ['Cmd', 'K'], description: 'Open command palette' },
      { keys: ['?'], description: 'Show this help' },
      { keys: ['Esc'], description: 'Close any open dialog or palette' },
    ],
  },
  {
    group: 'Moderation',
    items: [
      { keys: ['a'], description: 'Approve current submission' },
      { keys: ['r'], description: 'Reject current submission' },
      { keys: ['w'], description: 'Withdraw current submission' },
      { keys: ['c'], description: 'Request changes from contributor' },
    ],
  },
];

export default function KeyboardHelp({ open, onOpenChange }: KeyboardHelpProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="dlg-content--keyboard-help">
        <DialogTitle>Keyboard shortcuts</DialogTitle>
        <DialogDescription>
          Shortcuts are ignored while you are typing into an input or textarea.
        </DialogDescription>
        <div className="keyboard-help" data-testid="keyboard-help">
          {SHORTCUTS.map((group) => (
            <section key={group.group} aria-labelledby={`kh-${group.group}`}>
              <h3 id={`kh-${group.group}`}>{group.group}</h3>
              <table className="keyboard-help__table">
                <tbody>
                  {group.items.map((item) => (
                    <tr key={item.description}>
                      <td className="keyboard-help__keys">
                        {item.keys.map((k, i) => (
                          <span key={`${k}-${i}`}>
                            {i > 0 && <span aria-hidden="true">+</span>}
                            <kbd>{k}</kbd>
                          </span>
                        ))}
                      </td>
                      <td>{item.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>
          ))}
        </div>
        <div className="dlg-footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => onOpenChange(false)}
          >
            Close
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
